import React from "react";

const FullPageLoader = ({ message = "Loading..." }) => (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
        <span className="spinner-border text-primary mb-3" role="status" aria-hidden="true" />
        <p className="text-muted mb-0">{message}</p>
    </div>
);

export default FullPageLoader;
